
import { AxiosError } from 'axios';
import React from 'react';
import { useFormikContext } from 'formik';
import { useCallback, useState } from 'react';
import { components } from "react-select";
import { MultiValue, SingleValue, StylesConfig, ValueContainerProps, } from 'react-select/dist/declarations/src';
import styles from "./MultipleSelectBoxApiCall.module.css";
import { Badge } from 'reactstrap';
import { MisterIcon } from '@rtel/mister-icons';
import ReactSelect from 'react-select';

const MultpleSelectBoxFormik = ({defaultValues, name, className, onChange, selectedValues }: MultpleSelectBoxFormikProps) => {
  const { setFieldValue, values } = useFormikContext();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [moreValuesExistInDB, setMoreValuesExistInDB] = useState(false);
  const [allOptionValues, setAllOptionValues] = useState(defaultValues ? defaultValues : []);

  const maxResults = 100;

  const customStyle = {
    bgSelectedColor: "#f5f7fe",
    bgHoverColor: "#dbe0f3",
    textColor: "#495057"
  }

  const onMenuOpen = () => setIsMenuOpen(true);

  const onMenuClose = () => {
    setIsMenuOpen(false);
    setMoreValuesExistInDB(false);   
  }

  const handleInputChange = (input: string) => {
    if (input == ""){
      setMoreValuesExistInDB(false);
    }
  }

  const triggerProps = (formikElementProps: any, currentSelectedOption: any) => {
    console.log("formikElementProps: any", formikElementProps, "currentSelectedOption: any", currentSelectedOption)
    let newValues: any;
    //formikElementProps.selectOption(currentSelectedOption);
    console.log("props.selectedValues", selectedValues)
    if(!selectedValues) { return };

    if (selectedValues.includes(currentSelectedOption)) {
      // If the item is already in the array, remove it
      newValues = selectedValues.filter((item) => item !== currentSelectedOption);
    } else {
      // If the item is not in the array, add it
      newValues = [...selectedValues, currentSelectedOption];
    }
    
    if (onChange) {  
      onChange(defaultValues, currentSelectedOption)
    };
    
  }

  const MenuList = (props: any) => {
    if (props.isLoading) {
      return <components.MenuList {...props} />;
    }
    
    return (
      <>
        <components.ValueContainer {...props}>
          {props.children.length > 0 && `${props.children.length} items`}
        </components.ValueContainer >
        <components.MenuList {...props} className={styles.menuContainer}>
          {props.children.length > 0 ?
            <div >
              <div className={styles.optionsContainer}>
                {props.children.map((option: any, index: number) => {
                  return(
                  <label
                    key={index}
                    className='d-flex mb-0'
                    style={{background: option.props.isSelected ? customStyle.bgSelectedColor : "#ffffff" }}
                    onClick={() => triggerProps(props, option.props.data)}
                  >
                   
                    <input
                      type="checkbox"
                      checked={option.props.isSelected}
                      onChange={() => props.selectOption(option.props.data)}
                      className='d-flex'
                      style={{margin: "10px", background: option.props.isSelected ? customStyle.bgSelectedColor : "#ffffff" }}
                    />
                    <div className='d-flex flex-fill me-2'>{option}</div>
                  </label>
                  );
                })}
              </div>
              { allOptionValues.length > 1 && 
                 <span
                 className={styles.selectAll}
                 onClick={() => selectAllAction(props)}
               >
                 Select All
               </span> 
              }
           
            </div>
          :
            <components.NoOptionsMessage {...props}>
              <span className="custom-css-class">No Options</span>
            </components.NoOptionsMessage>
          }

        </components.MenuList>
      </>
    );
  };

  const ValueContainer = useCallback(({
    children,
    ...props
  }: ValueContainerProps<ISearchDropdown>) => {
    let [values, input] = children as any; //dont delete this unused "values"
    let counterValuesMessage: string = "";

    const valuesArray: ISearchDropdown[] = Array.isArray(props.selectProps.value)
    ? props.selectProps.value
    : props.selectProps.value ? [props.selectProps.value] : [];

    if (valuesArray) {
      const plural = valuesArray.length === 1 ? "" : "s";
      counterValuesMessage = `${valuesArray.length} item${plural} selected`;
    }

    return (
      <components.ValueContainer {...props}>
        {input}
        {valuesArray.length > 0 && (
          <Badge color="info">{counterValuesMessage}</Badge>
        )}
      </components.ValueContainer>
    );
  },[]);

  const selectAllAction = (reactSelectProps: any) => {
    if (!defaultValues) { return ;}
    let ids = new Set(defaultValues.map(d => d.value));
    let merged = [...defaultValues, ...allOptionValues.filter(d => !ids.has(d.value))];

    triggerHandleChange(merged);
    reactSelectProps.setValue(merged);
    if(onChange){
      onChange(merged, []);
    }
  }

  const triggerHandleChange = (val: MultiValue<ISearchDropdown> | SingleValue<ISearchDropdown>) => {
    console.log("props.name", name, "val:", val)
    const _val = val as ISearchDropdown[] | ISearchDropdown;
    let sortedValues: ISearchDropdown[] | ISearchDropdown = _val;

    const isArray = Array.isArray(_val);
    if (isArray) {
      sortedValues = [..._val].sort((a, b) =>
        a.label > b.label ? 1 : -1,
      );
    }
    setFieldValue(name, val);
  }

  const selectStyle: StylesConfig<ISearchDropdown, boolean> = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? customStyle.bgSelectedColor : "#fffff",
      color: customStyle.textColor,
      '&:hover': {
        color: customStyle.textColor,
        background: customStyle.bgHoverColor,
      },
    })
  }

  const ClearIndicator = (clearProps: any) => {
    return (
      <components.DropdownIndicator
        {...clearProps}
        innerProps={{
          ...clearProps.innerProps,
        }}
      >
        <div
          onMouseDown={() => {
            if(onChange) {
             onChange([], [clearProps.options])}
            }
          }
          onTouchEnd={() => {
            if(onChange) {
              onChange([], [clearProps.options])}
            }
          }
        >
          <MisterIcon name='XClose' size={'sm'} />
        </div>
      </components.DropdownIndicator>
    )
  }

  return (
    <>
      {!!moreValuesExistInDB && !!isMenuOpen && (
        <blockquote className={`bg-warning p-1`}>Over {maxResults} results found. Please refine your search.</blockquote>
      )}

      <ReactSelect
        //cacheOptions
        isMulti
        options={defaultValues}
        isSearchable
        value={selectedValues}
        onChange={triggerHandleChange}
        className={className}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        onInputChange={handleInputChange}
        components={{ MenuList, ValueContainer, ClearIndicator }}
        styles={selectStyle}
        menuIsOpen={isMenuOpen}
        
      />
    </>
  );
}

export default MultpleSelectBoxFormik;

export interface ISearchDropdown {
  value: string;
  label: string;
}

interface MultpleSelectBoxFormikProps {
  selectedValues?: ISearchDropdown [];
  defaultValues: ISearchDropdown [] | undefined;
  name: string;
  className?: string;
  onChange?: (allSelectedData: any, changedData: any) => void;

}

MultpleSelectBoxFormik.defaultProps = {
  className: "",
  value: [],
}